import Splide from '@splidejs/splide';

const timezoneMap = {
  nyc: 'America/New_York',
  la: 'America/Los_Angeles',
  london: 'Europe/London',
  paris: 'Europe/Paris',
  dubai: 'Asia/Dubai',
  beijing: 'Asia/Shanghai',
};

export default class FooterTicker {
  constructor(elem, APP) {
    this.elem = elem;
    this.ticker = this.elem.querySelector('.splide');
    this.intervalId = null;
  }

  updateTimes() {
    const timeElements = this.elem.querySelectorAll('.footer__ticker-time');

    timeElements.forEach((el) => {
      const cityClass = [...el.classList].find(c => c.startsWith('footer__ticker-time--'));
      if (!cityClass) return;

      const cityKey = cityClass.replace('footer__ticker-time--', '');
      const timezone = timezoneMap[cityKey];
      if (!timezone) return;

      const now = new Date();
      const options = {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: timezone,
      };
      const formatter = new Intl.DateTimeFormat('en-US', options);
      const formattedTime = formatter.format(now);

      el.textContent = formattedTime;
    });
  }

  init() {
    const width = window.innerWidth;
    const tickerHeight = width <= 480 ? '70px' : '50px';

    const splide = new Splide(this.ticker, {
      direction: 'ttb',
      autoWidth: true,
      height: tickerHeight,
      perPage: 1,
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 2000,
      type: 'loop',
      speed: 500,
      easing: 'ease'
    });

    splide.mount();

    // Fallback: force height via inline style
    this.ticker.style.height = tickerHeight;

    this.updateTimes(); // initial time update

    this.intervalId = setInterval(() => {
      this.updateTimes();
    }, 60000); // update every 60 seconds
  }

  destroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
